import React from 'react';
import '../template-file-css/document-file-template.css';


export const FWC_ClientLegalForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='FWC_ClientLegalForm' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-750'> <center> <h2> Demographics (Client Emergency/Contact Information) </h2> </center> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> First Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Last Name: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input id='txtFirstName' name='txtFirstName' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input id='txtLastName' name='txtLastName' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> SS#: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DOB: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input id='txtSs' name='txtSs' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input id='txtDob' name='txtDob' type='date' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Gender: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Race: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female &nbsp;
                        </td>
                        <td className='w-375'> <input id='txtRace' name='txtRace' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Insurance Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Insurance #: </span> </td>

                    </tr>

                    <tr>
                        <td className='w-375'> <input id='txtInsuranceName' name='txtInsuranceName' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input id='txtInsuranceNo' name='txtInsuranceNo' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNoInsurance' name='cbNoInsurance' className='add-only' value='No Insurance' /> No Insurance
                        </td>
                        <td className='w-250'> </td>
                        <td className='w-250'> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Street: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> ZIP: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtStreet' name='txtStreet' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtCity' name='txtCity' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtZip' name='txtZip' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-187'> <span className='eleHeader'> Home #: </span> </td>
                        <td className='w-187'> <span className='eleHeader'> Cell Phone: </span> </td>
                        <td className='w-187'> <span className='eleHeader'> Alternate Contact Numbers: </span> </td>
                        <td className='w-187'> <span className='eleHeader'> Email: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input id='txtHome' name='txtHome' type='text' className='add-only' /> </td>
                        <td className='w-187'> <input id='txtCellPhone' name='txtCellPhone' type='text' className='add-only' /> </td>
                        <td className='w-187'> <input id='txtAlternateContactNumbers' name='txtAlternateContactNumbers' type='text' className='add-only' /> </td>
                        <td className='w-187'> <input id='txtEmail' name='txtEmail' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Emergency Contact #1: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Relationship: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtEmergencyContact_1' name='txtEmergencyContact1' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtName_1' name='txtName1' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtRelationship_1' name='txtRelationship1' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Home #: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Work #: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Cell Phone #: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtHome_1' name='txtHome1' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtWork_1' name='txtWork1' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtCellPhone_1' name='txtCellPhone1' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Emergency Contact #2: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Relationship: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtEmergencyContact_2' name='txtEmergencyContact2' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtName_2' name='txtName2' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtRelationship_2' name='txtRelationship2' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Home #: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Work #: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Cell Phone #: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtHome_2' name='txtHome2' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtWork_2' name='txtWork2' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtCellPhone_2' name='txtCellPhone2' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <b> <center> <h3> Other Contact Number </h3> </center> </b> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Physician Name: </span> </td>
                        <td className='w-300'> <span className='eleHeader'> Address: </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Phone Number: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtPhysicianName' name='txtPhysicianName' type='text' className='add-only' /> </td>
                        <td className='w-300'> <input id='txtAddress' name='txtAddress' type='text' className='add-only' /> </td>
                        <td className='w-200'> <input id='txtPhoneNumber' name='txtPhoneNumber' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Known Allergies: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <input id='txtKnownAllergies' name='txtKnownAllergies' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Pharmacy Name: </span> </td>
                        <td className='w-300'> <span className='eleHeader'> Address: </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Phone Number: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtPharmacyName' name='txtPharmacyName' type='text' className='add-only' /> </td>
                        <td className='w-300'> <input id='txtAddress_1' name='txtAddress1' type='text' className='add-only' /> </td>
                        <td className='w-200'> <input id='txtPhoneNumber_1' name='txtPhoneNumber1' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Caseworker Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Contact Number: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Other: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtCaseworkerName' name='txtCaseworkerName' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtContactNumber' name='txtContactNumber' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtContactNumberOther' name='txtContactNumberOther' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <b> <center> <h3> PROGRAM PARTICIPANT'S RIGHTS AND RESPONSIBILITIES ACKNOWLEDGMENT </h3> </center> </b> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Insurance Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Insurance #: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input id='txtName' name='txtName' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtInsuranceName' name='txtInsuranceName' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input id='txtInsuranceNumber' name='txtInsuranceNumber' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> Every program participant at Family Wellness Center, LLC., has human/civil/personal rights to
                            be respected and honored. In addition, it is the responsibility of all program participants to act in a manner that respects the rights of others. Family Wellness Center, LLC., is committed to the protection of individual rights and to providing services within an environment that is characterized by dignity and respect of all persons, and is responsive to the unique needs, abilities, and characteristics of each person served by the organization.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <b> Family Wellness Center (FWC) is committed to providing reasonable accommodations for
                            consumers upon request and is fully compliant with the American with Disabilities Act (ADA). </b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <b> Family Wellness Center does not and shall not discriminate on the basis of race, color, religion
                            (creed), gender, gender expression, age, national origin (ancestry), disability, marital status, sexual
                            orientation, or military status, in any of its activities or operations. </b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <b> Program Participant Rights: </b> As a participant in programming of Family Wellness Center, LLC, you have the right to:
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_1' name='cbProgramParticipantRights_1' className='add-only' value='Be fully informed about the course of your care and decisions that may affect your treatment' /> Be fully informed about the course of your care and decisions that may affect your treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_2' name='cbProgramParticipantRights_2' className='add-only' value='Revoke your consent for treatment at any time' /> Revoke your consent for treatment at any time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_3' name='cbProgramParticipantRights_3' className='add-only' value=' Timely and accurate information to assist you in making sound decisions about your treatment' /> Timely and accurate information to assist you in making sound decisions about your treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_4' name='cbProgramParticipantRights_4' className='add-only' value='Be fully involved as an active participant in decisions pertaining to your treatment' /> Be fully involved as an active participant in decisions pertaining to your treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_5' name='cbProgramParticipantRights_5' className='add-only' value='Have an individual identified in writing that will direct and coordinate your treatment' /> Have an individual identified in writing that will direct and coordinate your treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_6' name='cbProgramParticipantRights_6' className='add-only' value='Request a change in individual directing and coordinating our treatment, if you so desire;' /> Request a change in individual directing and coordinating our treatment, if you so desire;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_7' name='cbProgramParticipantRights_7' className='add-only' value='Receive services in an environment that is free of all forms of abuse, including, but not limited to,' /> Receive services in an environment that is free of all forms of abuse, including, but not limited to,

                            <ol type='a'>
                                <li>financial abuse,</li>
                                <li>physical abuse and punishment,</li>
                                <li>sexual abuse and exploitation,</li>
                                <li>psychological abuse including humiliation, threats and exploitation,</li>
                                <li>all forms of seclusion and restraint</li>
                            </ol>


                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_8' name='cbProgramParticipantRights_8' className='add-only' value='Have information about your treatment and your confidentiality protected to the greatest extent allowed by federal and state confidentiality laws and regulations' /> Have information about your treatment and your confidentiality protected to the greatest extent allowed by federal and state confidentiality laws and regulations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_9' name='cbProgramParticipantRights_9' className='add-only' value='File a grievance or complaint about the services you receive without fear of retaliation or reprisal of any sort' /> File a grievance or complaint about the services you receive without fear of retaliation or reprisal of any sort
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_10' name='cbProgramParticipantRights_10' className='add-only' value='Have family members, friends or others involved in your treatment with your consent and approval' /> Have family members, friends or others involved in your treatment with your consent and approval
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_11' name='cbProgramParticipantRights_11' className='add-only' value='Receive services that comply with all applicable federal and state laws, rules and regulations' /> Receive services that comply with all applicable federal and state laws, rules and regulations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_12' name='cbProgramParticipantRights_12' className='add-only' value='File a grievance with an outside third party if you feel that the organization has not satisfactorily addressed any concerns you have or, does not adequately address any formal grievance you submit' /> File a grievance with an outside third party if you feel that the organization has not satisfactorily addressed any concerns you have or, does not adequately address any formal grievance you submit
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_13' name='cbProgramParticipantRights_13' className='add-only' value='To request a transfer to another program if you believe you are not receiving care that is meeting your needs and preferences.' /> To request a transfer to another program if you believe you are not receiving care that is meeting your needs and preferences.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantRights_14' name='cbProgramParticipantRights_14' className='add-only' value='You may also have additional rights afforded to you based on federal, state, and local regulations. Your service coordinator will advise you of any additional rights that you may have.' /> You may also have additional rights afforded to you based on federal, state, and local regulations. Your service coordinator will advise you of any additional rights that you may have.
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <b> <center> <h4> PROGRAM PARTICIPANT'S RIGHTS AND RESPONSIBILITIES ACKNOWLEDGMENT </h4> </center> </b> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <b> Program Participant Responsibilities:</b> As a program participant of FAMILY WELLNESS CENTER,
                            LLC., you have the responsibility to:
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_1' name='cbProgramParticipantResponsibilities_1' className='add-only' value='Refrain from abusive language, disruptive behavior or overt sexual conduct' /> Refrain from abusive language, disruptive behavior or overt sexual conduct
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_2' name='cbProgramParticipantResponsibilities_2' className='add-only' value='Be courteous to other consumers and staff' /> Be courteous to other consumers and staff
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_3' name='cbProgramParticipantResponsibilities_3' className='add-only' value='Attend services alcohol and drug free' /> Attend services alcohol and drug free
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_4' name='cbProgramParticipantResponsibilities_4' className='add-only' value='Ask questions about anything you do not understand' /> Ask questions about anything you do not understand
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_5' name='cbProgramParticipantResponsibilities_5' className='add-only' value='Actively participate in your treatment and in meeting your goals' /> Actively participate in your treatment and in meeting your goals
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_6' name='cbProgramParticipantResponsibilities_6' className='add-only' value='Notify any outside treatment provider (Physician, case worker, counselor, etc.) of participation in services, should your treatment impact, or compromise, the provision of those services' /> Notify any outside treatment provider (Physician, case worker, counselor, etc.) of participation in services, should your treatment impact, or compromise, the provision of those services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_7' name='cbProgramParticipantResponsibilities_7' className='add-only' value='Treat other program participants, staff, and visitors in a respectable manner.' /> Treat other program participants, staff, and visitors in a respectable manner.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_8' name='cbProgramParticipantResponsibilities_8' className='add-only' value='Inform your clinician if you wish to discontinue therapyt' /> Inform your clinician if you wish to discontinue therapy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_9' name='cbProgramParticipantResponsibilities_9' className='add-only' value='Inform your clinician should you have any special needs' /> Inform your clinician should you have any special needs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_10' name='cbProgramParticipantResponsibilities_10' className='add-only' value='Relate your strengths, needs, abilities and preferences to your clinician as honestly and completely as possible' /> Relate your strengths, needs, abilities and preferences to your clinician as honestly and completely as possible
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_11' name='cbProgramParticipantResponsibilities_11' className='add-only' value='Refrain from the use of tobacco products, illegal or legal substances while n the clinic' /> Refrain from the use of tobacco products, illegal or legal substances while n the clinic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_12' name='cbProgramParticipantResponsibilities_12' className='add-only' value='Refrain from bringing weapons in the clinic' /> Refrain from bringing weapons in the clinic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProgramParticipantResponsibilities_13' name='cbProgramParticipantResponsibilities_13' className='add-only' value='Notify Family Wellness Center if prescription medication is on the consumer while in the clinic' /> Notify Family Wellness Center if prescription medication is on the consumer while in the clinic
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'> By my signature below, I acknowledge that I have read and understand my rights and responsibilities as a participant in services at Family Wellness Center, LLC.
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'> Participant Name </td>
                        <td className='small w-300'> Participant Signature </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>


                <p className='signature w-750'>&nbsp; </p>
                <p className='small w-750'> Staff Member Name / Title / Signature/Date
                </p>


                <p className='w-750'>
                    <center> <b> <h2> FAMILY WELLNESS CENTER LLC. </h2> </b> </center>
                </p>
                <p className='w-750'>
                    <center> <b> <h5> Limits of Confidentiality </h5> </b> </center>
                </p>

                <p className='w-750'> The contents of a counseling, intake, or assessment session are considered to be confidential. Both verbal
                    information and written records about a client cannot be shared with another party without the written consent of the client or the client's legal guardian. It is the policy of this organization not to release any information about a client without a signed release of information. Noted exceptions are as follows:
                </p>

                <p className='w-750'>
                    <center> <b> <h5> Duty to Warn and Protect </h5> </b> </center>
                </p>

                <p className='w-750'> When a client discloses intentions or a plan to harm another person, the health care professional is required to warn           the intended victim and report this information to legal authorities. In cases in which the client discloses or implies a plan for suicide, the health care professional is required to notify legal authorities and make reasonable attempts to notify the family of the client.
                </p>

                <p className='w-750'>
                    <center> <b> <h5> Abuse of Children and Vulnerable Adults </h5> </b> </center>
                </p>
                <p className='w-750'> If a client states or suggests that he or she is abusing a child (or vulnerable adult) or has recently abused a child (or
                    vulnerable adult), or a child (or vulnerable adult) is in danger of abuse, the health care professional is required to
                    report this information to the appropriate social service and/or legal authorities.
                </p>

                <p className='w-750'>
                    <center> <b> <h5> Prenatal Exposure to Controlled Substances </h5> </b> </center>
                </p>
                <p className='w-750'> Health care professionals are required to report admitted prenatal exposure to controlled substances that are
                    potentially harmful.
                </p>

                <p className='w-750'>
                    <center> <b> <h5> In the Event of a Client's Death </h5> </b> </center>
                </p>
                <p className='w-750'> In the event of a client's death, the spouse or parents of a deceased client have a right to access their child's or
                    spouse's records.
                </p>

                <p className='w-750'>
                    <center> <b> <h5> Professional Misconduct </h5> </b> </center>
                </p>
                <p className='w-750'> Other health care professionals must report professional misconduct by a health care professional. In cases in which
                    a professional or legal disciplinary meeting is being held regarding the health care professional's actions, related
                    records may be released in order to substantiate disciplinary concerns.
                </p>

                <p className='w-750'>
                    <center> <b> <h5> Court Orders </h5> </b> </center>
                </p>
                <p className='w-750'> Health care professionals are required to release records of clients when a court order has been placed. Clients who
                    are on probation, court ordered to treatment or referred by the Department of Juvenile Justice, Department of
                    Human Resources or the county Juvenile Court may have waived certain rights to confidentiality when entering the
                    Intensive Family Intervention program.
                </p>

                <p className='w-750'>
                    <center> <b> <h5> Minors/Guardianship </h5> </b> </center>
                </p>
                <p className='w-750'> Parents or legal guardians of non-emancipated minor clients have the right to access the client's records.
                </p>

                <p className='w-750'>
                    <center> <b> <h5> Audio/Video Taping </h5> </b> </center>
                </p>
                <p className='w-750'> In the event it becomes necessary to audio and/or video tape a client for treatment or supervision purposes, a specific      consent form for the purpose of audio and/or video will be required. No recordings on any kind will be conducted without the expressed consent of the client.
                </p>
                <br />

                <p className='w-750'>
                    <center> <b> <h5> Other Provisions </h5> </b> </center>
                </p>
                <br />
                <p className='w-750'> Family Wellness Center, LLC., does not conduct research on any of their clients. Outcome measure, as pertains to the
                    effectiveness or non-effectiveness of the Intensive Family Intervention Program, are collected and
                    analyzed to ensure that the best quality treatment is provided. No personal information on any client is disclosed,
                    nor can any client be identified by any of outcome information collected.
                </p>

                <p className='w-750'> Insurance companies and other third-party payers are given information that they request regarding services to
                    clients. Information that may be requested includes type of services, dates/times of services, diagnosis, treatment
                    plan, and description of impairment, progress of therapy, case notes, and summaries.
                </p>

                <p className='w-750'> Information about clients may be disclosed in consultations with other professionals in order to provide the best
                    possible treatment. In such cases the name of the client, or any identifying information, is not disclosed. Clinical
                    information about the client is disclosed.
                </p>

                <p className='w-750'> In some cases, notes and reports are dictated/typed within the clinic or by outside sources specializing (and held
                    accountable) for such procedures.
                </p>

                <p className='w-750'>
                    When couples, groups, or families are receiving services, separate files are kept for individuals for information
                    disclosed that is of a confidential nature.
                    <br />
                    The information includes:
                    <ol type='a'>
                        <li>testing results,</li>
                        <li>information given to the mental health professional not in the presence of other person(s) utilizing services,</li>
                        <li>information received from other sources about the client,</li>
                        <li>diagnosis,</li>
                        <li>treatment plan,</li>
                        <li>individual reports/summaries, and</li>
                        <li>information that has been requested to be separate.</li>
                    </ol>
                </p>

                <p className='w-750'> The material disclosed in conjoint family or couple's sessions,
                    in which each party discloses such information in each other's presence, is kept in each file in the form of case
                    notes.
                </p>

                <p className='w-750'> In the event in which the company or mental health professional must telephone the client for purposes such as
                    appointment cancellations or reminders, or to give/receive other information, efforts are made to preserve
                    confidentiality. Please list where we may reach you by phone and how you would like us to identify ourselves. For
                    example, you might request that when we phone you at home or work, we do not say the name of the clinic or the
                    nature of the call, but rather the mental health professionals' first name only.
                </p>

                <p className='w-750'> Please check where you may be reached by phone. Include phone numbers and how you would like us to identify
                    ourselves when phoning you.
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHome' name='cbHome' className='add-only' value='Home' /> <b> Home </b> <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'> Phone Number: </span> </td>
                        <td className='w-500'>
                            <span className='eleHeader'> How should we identify ourselves? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtHowShouldWeIdentifyOurselves_1' name='txtHowShouldWeIdentifyOurselves_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> May we say the Clinic Name? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbYes_1' name='rbClinicName_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_1' name='rbClinicName_1' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOffice' name='cbOffice' className='add-only' value='Office' /> <b> Office </b> <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'> Phone Number: </span> </td>
                        <td className='w-500'>
                            <span className='eleHeader'> How should we identify ourselves? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhoneNumber_2' name='txtPhoneNumber_2' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtHowShouldWeIdentifyOurselves_2' name='txtHowShouldWeIdentifyOurselves_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> May we say the Clinic Name? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbYes_2' name='rbClinicName_2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_2' name='rbClinicName_2' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEmergency' name='cbEmergency' className='add-only' value='Emergency' /> <b> Emergency </b> <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'> Phone Number: </span> </td>
                        <td className='w-500'>
                            <span className='eleHeader'> How should we identify ourselves? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhoneNumber_3' name='txtPhoneNumber_3' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtHowShouldWeIdentifyOurselves_3' name='txtHowShouldWeIdentifyOurselves_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> May we say the Clinic Name? </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbYes_3' name='rbClinicName_3' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_3' name='rbClinicName_3' className='add-only' value='No' /> No &nbsp;
                        </td>
                    </tr>
                </table>

                <p className='w-750'> I agree to the above limits of confidentiality and understand their meanings and ramifications.
                </p>

                <table>
                    <tr>
                        <td className='signature w-350'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-350'> Participant Name </td>
                        <td className='small w-200'> Participant Signature </td>
                        <td className='small w-200'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-350'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-350'> Relationship to Client: </td>
                        <td className='small w-200'> Staff Member </td>
                        <td className='small w-200'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center> <b> <h3> Family Wellness Center, LLC. </h3> </b> </center>
                </p>
                <p className='w-750'>
                    <center> <b> <h5> Notice of Privacy Practices </h5> </b> </center>
                </p>

                <p className='small w-750'>
                    <center> THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE
                        USED AND DISCLOSED AND HOW YOU CAN GET ACCESS TO THIS INFORMATION.
                        PLEASE REVIEW THIS NOTICE CAREFULLY. </center>
                </p>

                <p className='w-750'>
                    Your health record contains personal information about you and your health. This information about you that may identify you and that relates to your past, present or future physical or mental health or condition and related health care services is referred to as Protected Health Information (“PHI”). This Notice of Privacy Practices describes how we may use and disclose your PHI in accordance with applicable law and the NASW Code of Ethics. It also describes your rights regarding how you may gain access to and control your PHI.
                </p>

                <p className='w-750'>
                    We are required by law to maintain the privacy of PHI and to provide you with notice of our legal duties and privacy practices with respect to PHI. We are required to abide by the terms of this Notice of Privacy Practices. We reserve the right to change the terms of our Notice of Privacy Practices at any time. Any new Notice of Privacy Practices will be effective for all PHI that we maintain at that time. We will provide you with a copy of the revised Notice of Privacy Practices by posting a copy on our website, sending a copy to you in the mail upon request or providing one to you at your next appointment.
                </p>

                <p className='w-750'>
                    <center> <b> <h3> How We May Use and Disclose Health Information About You </h3> </b> </center>
                </p>

                <p className='w-750'>
                    <b> For Treatment. </b>  Your PHI may be used and disclosed by those who are involved in your care for the purpose of providing, coordinating, or managing your health care treatment and related services. This includes consultation with clinical supervisors or other treatment team members.  We may disclose PHI to any other consultant only with your authorization.
                </p>

                <p className='w-750'>
                    <b> For Payment. </b> We may use and disclose PHI so that we can receive payment for the treatment services provided to you. This will only be done with your authorization. Examples of payment-related activities are: making a determination of eligibility or coverage for insurance benefits, processing claims with your insurance company, reviewing services provided to you to determine medical necessity, or undertaking utilization review activities. If it becomes necessary to use collection processes due to lack of payment for services, we will only disclose the minimum amount of PHI necessary for purposes of collection.
                </p>

                <p className='w-750'>
                    <b> For Health Care Operations. </b> We may use or disclose, as needed, your PHI in order to support our business activities including, but not limited to, quality assessment activities, employee review activities, licensing, and conducting or arranging for other business activities. For example, we may share your PHI with third parties that perform various business activities (e.g., billing or typing services) provided we have a written contract with the business that requires it to safeguard the privacy of your PHI. For training or teaching purposes PHI will be disclosed only with your authorization. [If you plan to use PHI to remind a client of appointments, to provide information about treatment alternatives or other health -related benefits and services, for fundraising purposes or for facility directories and if doing so is permitted by applicable state law, the Notice of Privacy Practices must state so.]
                </p>

                <p className='w-750'>
                    <b> Required by Law. </b> Under the law, we must make disclosures of your PHI to you upon your request. In addition, we must make disclosures to the Secretary of the Department of Health and Human Services for the purpose of investigating or determining our compliance with the requirements of the Privacy Rule.
                </p>

                <p className='w-750'>
                    The purpose of the following Section is for the Covered Entity to provide a summary of all the types of uses and disclosures other than treatment, payment and health care operations that are possible without a patient's/client's authorization. Unlike the other parts of this Notice, which are generic enough so that they could be used in every state, this Section MUST be tailored to reflect the types of uses and disclosures permitted not only by the Privacy Standards but also by other applicable state and federal law.
                </p>

                <p className='w-750'>
                    Following is a list of the categories of uses and disclosures permitted by HIPAA without an authorization.
                    <ul>
                        <li>Abuse and Neglect</li>
                        <li>Judicial and Administrative Proceedings</li>
                        <li>Deceased Persons</li>
                        <li>Emergencies</li>
                        <li>Family Involvement in Care</li>
                        <li>Health Oversight</li>
                        <li>Law Enforcement</li>
                        <li>National Security</li>
                        <li>Public Health</li>
                        <li>Public Safety (Duty to Warn)</li>
                        <li>Research</li>
                    </ul>
                </p>

                <p className='w-750'> You should determine which of these uses and disclosures are permitted in your state for the type of information that you will be using or disclosing.
                </p>

                <p className='w-750'> The following language addresses these categories to the extent consistent with the NASW Code of Ethics.
                </p>

                <p className='w-750'> <b> Without Authorization.: </b>
                </p>

                <p className='w-750'> Applicable law and ethical standards permit us to disclose information about you without your authorization only in a limited number of other situations. The types of uses and disclosures that may be made without your authorization are those that are:
                    <ul>
                        <li>Required by Law, such as the mandatory reporting of child abuse or neglect or mandatory government agency audits or investigations (such as the social work licensing board or the health department)</li>
                        <li>Required by Court Order</li>
                        <li>Necessary to prevent or lessen a serious and imminent threat to the health or safety of a person or the public. If information is disclosed to prevent or lessen a serious threat it will be disclosed to a person or persons reasonably able to prevent or lessen the threat, including the target of the threat.</li>
                    </ul>
                </p>

                <p className='w-750'> <b> Verbal Permission: </b>
                </p>

                <p className='w-750'> We may use or disclose your information to family members that are directly involved in your treatment with your verbal permission. With Authorization. Uses and disclosures not specifically permitted by applicable law will be made only with your written authorization, which may be revoked.
                </p>

                <p className='w-750'>
                    <center> <b> <h3> YOUR RIGHTS REGARDING YOUR PHI </h3> </b> </center>
                </p>

                <p className='w-750'> You have the following rights regarding PHI we maintain about you. To exercise any of these rights, please submit your request in writing to our Privacy Officer at 3883 Rogers Bridge Road, Ste 202A, Duluth Ga. 30097.
                </p>

                <p className='w-750'> <b> Right of Access to Inspect and Copy. </b>
                </p>

                <p className='w-750'> You have the right, which may be restricted only in exceptional circumstances, to inspect and copy PHI that may be used to make decisions about your care. Your right to inspect and copy PHI will be restricted only in those situations where there is compelling evidence that access would cause serious harm to you. <b> We may charge a reasonable, cost-based fee for copies. </b>
                </p>

                <p className='w-750'>
                    <ol>
                        <li><b> Right to Amend. </b> If you feel that the PHI we have about you is incorrect or incomplete, you may ask us to amend the information although we are not required to agree to the amendment.</li>
                        <li><b> Right to an Accounting of Disclosures. </b> You have the right to request an accounting of certain of the disclosures that we make of your PHI. We may charge you a reasonable fee if you request more than one accounting in any 12-month period.</li>
                        <li><b> Right to Request Restrictions. </b> You have the right to request a restriction or limitation on the use or disclosure of your PHI for treatment, payment, or health care operations. We are not required to agree to your request.</li>
                        <li><b> Right to Request Confidential Communication. </b> You have the right to request that we communicate with you about medical matters in a certain way or at a certain location.</li>
                        <li><b> Right to a Copy of this Notice. </b> You have the right to a copy of this notice.</li>
                    </ol>
                </p>

                <p className='w-750'> <b> Complaints </b>
                </p>

                <p className='w-750'> If you believe we have violated your privacy rights, you have the right to file a complaint in
                    writing with our Privacy Officer at [Bola K. Olagbegi 3883 Rogers Bridge Road, Ste 202A, Duluth Ga. 30097. 770-545-8359] or with the Secretary of Health and Human Services at 200 Independence Avenue, S.W. Washington, D.C. 20201 or by calling (202) 619-0257. We will not retaliate against you for filing a complaint.
                </p>

                <p className='w-750'>
                    <center> <b> <h3> Consumer Grievances </h3> </b> </center>
                </p>

                <p className='w-750'> <b> Purpose </b>
                </p>

                <p className='w-750'> It is the policy of Family Wellness Center that all services provided to clients will be carried out in an environment that is supportive, confidential and respectful of the individual.  Family Wellness Center will be accessible and will maximize the individual's ability to make informed choices in relation to their lives.
                </p>

                <p className='w-750'> <b> Policy </b>
                </p>

                <p className='w-750'> The grievance policy for consumers is designed to facilitate effective service delivery. Each consumer will be required to sign a Consumer Grievance Signature form stating they have received a copy of the Consumer Grievance policy.
                </p>

                <p className='w-750'> <b> Procedures </b>
                </p>
                <p className='w-750'> <b> Section I </b>
                </p>
                <p className='w-750'> If any person believes that a member of Family Wellness Center staff has violated any one or more of the Consumer Rights, misinterpreted or misapplied the terms of the service agreement, he/she may bring forward a grievance to the Consumers Rights Officer.
                </p>

                <p className='w-750'>
                    <b> Terms and Conditions </b>
                    <ol>
                        <li><b> Terms: </b> The terms contained herein shall be defined as follows:</li>
                        <li><b> Grievance: </b> A complaint by one or more clients of an alleged violation, misinterpretation  or misapplication of the terms of the service agreement between Family Wellness Center and its client.</li>
                        <li><b> Representative: </b> Someone of the client's choice to represent them.</li>
                        <li><b> Consumers Rights Officer: </b> The Team Leader or Clinical Director of Family Wellness Center.</li>
                    </ol>
                </p>

                <p className='w-750'> <b> Grievant: </b> An employee/independent contractor or any client of the Family Wellness Center program.
                </p>
                <p className='w-750'>
                    <b> Conditions: </b>
                    <ol>
                        <li>If a grievance is not filed within twenty (20) working days of the date the grievant knew or should have known of the occurrence-giving rise to the grievance, it shall no longer exist.</li>
                        <li>Nothing contained herein shall interfere with the rights to meet voluntarily with the Family and Community Consumer Rights Officer.</li>
                        <li>Family Wellness Center Consumer Rights Officer shall be available to assist the complainant in the filing of the grievance.</li>
                        <li>The parties may, upon mutual agreement in writing, extend the time limits of the grievance procedure.</li>
                        <li>Family Wellness Center staff member who is being grieved against shall not be involved in assisting the complainant to complete the grievance, shall not be involved in the investigation of the process, and shall not be involved in the resolution of the grievance.</li>
                        <li>In the event that a grievance is directed at Family Wellness Center Consumer Right Officer, the Program Director or Administrator shall assume the responsibility to investigate the allegation.</li>
                    </ol>
                </p>

                <p className='w-750'> <b> Section II </b>
                </p>

                <p className='w-750'>
                    <b> Informal Level </b>
                </p>

                <p className='w-750'> The person who believes he/she has a valid basis for client inquiry or grievance may discuss the matter informally and on a verbal basis with the Family Wellness Center Consumer Rights Officer, who shall in turn, investigate the complaint and reply with an answer to the complainant within five (5) working days. This communication can occur via T/C or Face to Face by contacting the Consumer Rights Officer at the office number: 770-545-8359.
                </p>

                <p className='w-750'> <b> Section III </b>
                </p>

                <p className='w-750'>
                    <b> Formal Level </b>
                </p>

                <p className='w-750'> If the client is not satisfied with the discussion and/or resolution at the informal level, the client may file a grievance and initiate the formal procedures in accordance with the following:
                </p>

                <p className='w-750'> A written statement of the grievance signed and dated by the complainant shall be submitted to the Family Wellness Center Consumer Rights Officer within five (5) days of the informal meeting. The written grievance must include the date, time, description, and names of the individuals involved in the situation/incident being grieved.  Family Wellness Center Consumer Rights Officer, Program Director or Administrator shall further investigate the matters of the grievance and reply in writing to the complainant within five (5) working days.
                </p>
                <p className='w-750'> Written Statement can be submitted in person or addressed to the main office location: 3883 Rogers Bridge Road, Ste 202A, Duluth Ga. 30097.
                </p>

                <p className='w-750'> <b> Section IV </b>
                </p>

                <p className='w-750'>
                    <b> Appeal Level </b>
                </p>

                <p className='w-750'> If the client is not satisfied with the resolution at the previous level, he/she may appeal the decision to the State of Georgia Department of Human Resources in accordance with their policy and procedures.
                </p>

                <p className='w-750'>
                    <center> <b> <h4> RECEIPT AND ACKNOWLEDGEMENT OF HIPPA NOTICE OF PRIVACY PRACTICES </h4> </b> </center>
                </p>

                <p className='w-750'> I hereby acknowledge that I have received and have been given an opportunity to read a copy of Family Wellness Center Notice of Privacy Practices.
                </p>

                <p className='w-750'> I understand that if I have any questions regarding the Notice or my Privacy Rights, I can contact the Executive Director or Administrator of Family Wellness Center at 770-545-8359 or the Metro Regional Office for the Department of Health and Human Services (DHR).
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Name of Participant or Representative </td>
                        <td className='small w-375'> Signature of Participant or Representative </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Relationship to Client: </td>
                    </tr>

                    <tr>
                        <td className='w-750'> If you are signing as a personal representative of the consumer, please describe your legal authority to act for the consumer or the consumer's legal guardian (power of attorney, healthcare surrogate, legal guardian, parent)
                            <textarea id='txtPleaseDescribeYourLegalAuthority' name='txtPleaseDescribeYourLegalAuthority' className='add-only'> </textarea> </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <b> Please check here if the following applies: </b> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCurrentMood_1' name='cbCurrentMood_1' className='add-only' /> Consumer / Guardian or legal representative refuses to sign
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Staff Member </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center> <b> <h4> CLIENT ORIENTATION ACKNOWLEDGEMENT FORM </h4> </b> </center>
                    <br />
                    This is to acknowledge that I have received a copy of the Family Wellness Center Client Handbook and understand that it contains important information on the Family Wellness Center general program rules, treatment guidelines, privileges and my client rights as a participant in the program. I acknowledge that I have reviewed, understand and will comply with the provisions outlined in this handbook. I understand that violation of program rules and/or failure to comply with treatment may result in discharge from the program.
                </p>
                <table>

                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Participant </td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Signature/Date </td>
                    </tr>

                </table>
                <table>

                    <tr>
                        <td className='w-750'>
                            <center> <b> <h5> Consumer Grievance Policy Receipt & Acknowledgement Signature Page </h5> </b> </center>
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Participant </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <center> <b> <h4> CONSENT TO SERVICES </h4> </b> </center>
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    I,
                    <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only w-200 custom-add-only' />
                    will cooperate and give consent to Family Wellness Center LLC  to provide  Behavioral /Mental Health  Services  beginning
                    <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only w-200 custom-add-only' />
                    and ending according to service plan target dates or discharge service date.
                </p>

                <p className='w-750'>
                    I understand that this will involve home visits, office visits, telehealth visits and possible other community visits as needed.
                </p>

                <p className='w-750'>
                    I acknowledge that I am aware of the targeted  problem(s), the intervention(s) to be utilized, goal(s) of the treatment, discharge criteria and that I participated in the development of the individualized care plan. I acknowledge that participation in these services is voluntary and at any time I can request that the services are terminated.
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Participant Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Member Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center> <h4> <b> RELEASE AND EXCHANGE OF INFORMATION TO AGENCY (PCP) </b> </h4> </center>

                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Participant Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DOB: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='text' id='txtParticipantName' name='txtParticipantName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDob' name='txtDob' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Social Security#: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Insurance ID#: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtSocialSecurity' name='txtSocialSecurity' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtInsuranceId' name='txtInsuranceId' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <b> By my signature below, I authorize: </b> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name of PCP: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Address: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameOfPpc' name='txtNameOfPpc' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> State: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Zip: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtState' name='txtState' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtZip' name='txtZip' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Phone: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Fax: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Faxed: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtPhone' name='txtPhone' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtFax' name='txtFax' className='add-only' /> </td>
                        <td className='w-250'>
                            <input type='radio' id='rbFaxed_Yes' name='rbFaxed' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFaxed_No' name='rbFaxed' className='add-only' value='No' /> No

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Date: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Staff Initials: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtStaffInitials' name='txtStaffInitials' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <b> To disclose the following Protected Health Information (PHI) as checked below for Continued Treatment: </b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalRecordsPhysicalExams' name='cbMedicalRecordsPhysicalExams' className='add-only' value='Medical Records/Physical Exams' /> Medical Records/Physical Exams
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHp' name='cbHp' className='add-only' value='H&P, RPR, TB' /> H&P, RPR, TB </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychologicalPsychiatricEvaluationsSummaryNotes' name='cbPsychologicalPsychiatricEvaluationsSummaryNotes' className='add-only' value='Psychological / Psychiatric Evaluations /Summary Notes' /> Psychological / Psychiatric Evaluations /Summary Notes
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrescribedMedicationReportMonthlyEvaluation' name='cbcbPrescribedMedicationReportMonthlyEvaluation' className='add-only' value='Prescribed Medication(s) Report/ Monthly Evaluation' /> Prescribed Medication(s) Report/ Monthly Evaluation </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSocialMentalHealthHistory' name='cbSocialMentalHealthHistory' className='add-only' value='Social Mental Health History' /> Social Mental Health History
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMentalHealthAlcoholDrugAbuseTreatment' name='cbMentalHealthAlcoholDrugAbuseTreatment' className='add-only' value='Mental Health /Alcohol & Drug Abuse Treatment' /> Mental Health /Alcohol & Drug Abuse Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInitialAssessment' name='cbInitialAssessment' className='add-only' value='Initial Assessment' /> Initial Assessment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInTreatmentStatus' name='cbInTreatmentStatus' className='add-only' value='In-Treatment Status' /> In-Treatment Status
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentPlan' name='cbTreatmentPlan' className='add-only' value='Treatment Plan' /> Treatment Plan
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDischargeSummary' name='cbDischargeSummary' className='add-only' value='Discharge Summary' /> Discharge Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTransitionalPlan' name='cbTransitionalPlan' className='add-only' value='Transitional Plan' /> Transitional Plan
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDjjLegalCriminalRecords' name='cbDjjLegalCriminalRecords' className='add-only' value='DJJ/Legal Criminal Records' /> DJJ/Legal Criminal Records
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReportCardsSchoolRecords' name='cbReportCardsSchoolRecords' className='add-only' value='Report Cards / School Records' /> Report Cards / School Records
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDfcsRecords ' name='cbDfcsRecords' className='add-only' value='DFCS Records' /> DFCS Records
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIep' name='cbIep' className='add-only' value='IEP' /> IEP
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEeg ' name='cbEeg' className='add-only' value='EEG' /> EEG
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBloodWork' name='cbBloodWork' className='add-only' value='Blood Work' /> Blood Work
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b> To: <br />
                        Family Wellness Center<br />
                        3883 Rogers Bridge Road, Suite 202-A, Duluth, GA 30097, Office: 770-545-8359 Fax: 229-515-4233
                    </b>

                </p>
                <table>
                    <tr>
                        <td className='w-750'> <b> FOR THE FOLLOWING PURPOSES: </b> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAtMyRequest' name='cbAtMyRequest' className='add-only' value='At my request' /> At my request
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInpatientTreatment ' name='cbInpatientTreatment' className='add-only' value='Inpatient Treatment' /> Inpatient Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOutpatientTreatment' name='cbOutpatientTreatment' className='add-only' value='Outpatient Treatment' /> Outpatient Treatment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLegal' name='cbLegal' className='add-only' value='Legal' /> Legal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input id='txtOther' name='txtOther' type='text' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    This authorization is freely given to Family Wellness Center with the understanding that:
                    <ol>
                        <li>Any and all records, whether written, oral, or in electronic format, are confidential and cannot be disclosed without my prior written authorization, except as otherwise provided by law. Records released may contain alcohol and drug treatment information, patient photographs, AIDS/HIV or psychiatric/psychological/other mental health privileged or confidential information. Certain communications are privileged and not subject to release without your consent under state and/or federal law.</li>
                        <li>A photocopy or fax of this authorization is a valid as the original.</li>
                        <li>I understand that this authorization can be revoked at any time through notification in writing, except where information has already been released. This authorization is valid for a one year period from the date it is signed, or for less time, if noted below.</li>
                        <li>Treatment, payment, enrollment or eligibility for benefits may not be conditioned upon obtaining this recipient and is no longer protected.</li>
                        <li>Information used or disclosed pursuit to this authorization may be subject to re-disclosure by the recipient and is no longer protected.</li>
                    </ol>
                </p>

                <table>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Participant Signature </td>
                        <td className='small w-375'> Date Signed </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Signature, FWC, Title, Degree </td>
                        <td className='small w-375'> Expiration </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <center> <h3> RELEASE AND EXCHANGE OF INFORMATION TO AGENCY (Psychiatry) </h3> </center>
                </p>


                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Client's' Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DOB: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <input type='text' id='txtPsychiatryParticipantName' name='txtPsychiatryParticipantName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPsychiatryDob' name='txtPsychiatryDob' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Social Security#: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Insurance ID#: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPsychiatrySocialSecurity' name='txtPsychiatrySocialSecurity' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPsychiatryInsuranceId' name='txtPsychiatryInsuranceId' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <b> By my signature below, I authorize: </b> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name of Psychiatry: </span> </td>
                        <td className='w-375'> <input type='text' id='txtPsychiatryNameOfPpc' name='txtPsychiatryNameOfPpc' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Address: </span> </td>
                        <td className='w-375'> <input type='text' id='txtPsychiatryAddress' name='txtPsychiatryAddress' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> State: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Zip: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtPsychiatryCity' name='txtPsychiatryCity' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPsychiatryState' name='txtPsychiatryState' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPsychiatryZip' name='txtPsychiatryZip' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Phone: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Fax: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Faxed: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtPsychiatryPhone' name='txtPsychiatryPhone' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPsychiatryFax' name='txtPsychiatryFax' className='add-only' /> </td>
                        <td className='w-250'>
                            <input type='radio' id='rbPsychiatryFaxed_Yes' name='rbPsychiatryFaxed' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPsychiatryFaxed_No' name='rbPsychiatryFaxed' className='add-only' value='No' /> No

                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Date: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Staff Initials: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtPsychiatryDate' name='txtPsychiatryDate' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPsychiatryStaffInitials' name='txtPsychiatryStaffInitials' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <b> To disclose the following Protected Health Information (PHI) as checked below for Continued Treatment: </b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryMedicalRecordsPhysicalExams' name='cbPsychiatryMedicalRecordsPhysicalExams' className='add-only' value='Medical Records/Physical Exams' /> Medical Records/Physical Exams
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryHp' name='cbPsychiatryHp' className='add-only' value='H&P, RPR, TB' /> H&P, RPR, TB
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryPsychologicalPsychiatricEvaluationsSummaryNotes' name='cbPsychiatryPsychologicalPsychiatricEvaluationsSummaryNotes' className='add-only' value='Psychological / Psychiatric Evaluations /Summary Notes' /> Psychological / Psychiatric Evaluations /Summary Notes
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryPrescribedMedicationReportMonthlyEvaluation' name='cbPsychiatrycbPrescribedMedicationReportMonthlyEvaluation' className='add-only' value='Prescribed Medication(s) Report/ Monthly Evaluation' /> Prescribed Medication(s) Report/ Monthly Evaluation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatrySocialMentalHealthHistory' name='cbPsychiatrySocialMentalHealthHistory' className='add-only' value='Social Mental Health History' /> Social Mental Health History
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryMentalHealthAlcoholDrugAbuseTreatment' name='cbPsychiatryMentalHealthAlcoholDrugAbuseTreatment' className='add-only' value='Mental Health /Alcohol & Drug Abuse Treatment' /> Mental Health /Alcohol & Drug Abuse Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryInitialAssessment' name='cbPsychiatryInitialAssessment' className='add-only' value='Initial Assessment' /> Initial Assessment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryInTreatmentStatus' name='cbPsychiatryInTreatmentStatus' className='add-only' value='In-Treatment Status' /> In-Treatment Status
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryTreatmentPlan' name='cbPsychiatryTreatmentPlan' className='add-only' value='Treatment Plan' /> Treatment Plan
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryDischargeSummary' name='cbPsychiatryDischargeSummary' className='add-only' value='Discharge Summary' /> Discharge Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryTransitionalPlan' name='cbPsychiatryTransitionalPlan' className='add-only' value='Transitional Plan' /> Transitional Plan
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryDjjLegalCriminalRecords' name='cbPsychiatryDjjLegalCriminalRecords' className='add-only' value='DJJ/Legal Criminal Records' /> DJJ/Legal Criminal Records
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryReportCardsSchoolRecords' name='cbPsychiatryReportCardsSchoolRecords' className='add-only' value='Report Cards / School Records' /> Report Cards / School Records
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryDfcsRecords ' name='cbPsychiatryDfcsRecords' className='add-only' value='DFCS Records' /> DFCS Records
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryIep' name='cbPsychiatryIep' className='add-only' value='IEP' /> IEP
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryEeg ' name='cbPsychiatryEeg' className='add-only' value='EEG' /> EEG
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryBloodWork' name='cbPsychiatryBloodWork' className='add-only' value='Blood Work' /> Blood Work
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>
                        To: <br />
                        Family Wellness Center<br />
                        3883 Rogers Bridge Road, Suite 202-A, Duluth, GA 30097, Office: 770-545-8359 Fax: 229-515-4233
                    </b>

                </p>
                <table>
                    <tr>
                        <td className='w-750'> <b> FOR THE FOLLOWING PURPOSES: </b> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryAtMyRequest' name='cbPsychiatryAtMyRequest' className='add-only' value='At my request' /> At my request
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryInpatientTreatment ' name='cbPsychiatryInpatientTreatment' className='add-only' value='Inpatient Treatment' /> Inpatient Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryOutpatientTreatment' name='cbPsychiatryOutpatientTreatment' className='add-only' value='Outpatient Treatment' /> Outpatient Treatment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatryLegal' name='cbPsychiatryLegal' className='add-only' value='Legal' /> Legal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychiatryOther' name='cbPsychiatryOther' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input id='txtPsychiatryOther' name='txtPsychiatryOther' type='text' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    This authorization is freely given to Family Wellness Center with the understanding that:
                    <ol type="1">
                        <li>Any and all records, whether written, oral, or in electronic format, are confidential and cannot be disclosed without my prior written authorization, except as otherwise provided by law. Records released may contain alcohol and drug treatment information, patient photographs, AIDS/HIV or psychiatric/psychological/other mental health privileged or confidential information. Certain communications are privileged and not subject to release without your consent under state and/or federal law.</li>
                        <li>A photocopy or fax of this authorization is a valid as the original.</li>
                        <li>I understand that this authorization can be revoked at any time through notification in writing, except where information has already been released. This authorization is valid for a one year period from the date it is signed, or for less time, if noted below.</li>
                        <li>Treatment, payment, enrollment or eligibility for benefits may not be conditioned upon obtaining this recipient and is no longer protected.</li>
                        <li>Information used or disclosed pursuit to this authorization may be subject to re-disclosure by the recipient and is no longer protected.</li>
                    </ol>
                </p>

                <table>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Participant Signature </td>
                        <td className='small w-375'> Date Signed </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Signature, FWC, Title, Degree </td>
                        <td className='small w-375'> Expiration </td>
                    </tr>

                </table>





            </div>
        </form>

    )
}